import React from "react";
import { Link } from "react-router-dom";
import { FiCheckCircle, FiHome, FiUsers, FiShield, FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import PremiumHero from "../components/common/PremiumHero";

const Box = ({ title, icon, children }) => (
  <div className="bg-white border rounded-2xl p-6">
    <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
      <span className="text-[#e11d7b]">{icon}</span> {title}
    </h3>
    <div className="text-gray-700 leading-relaxed">{children}</div>
  </div>
);

export default function House() {
  return (
    <div className="bg-white">
      <PremiumHero
        title="Maxula House"
        subtitle="Votre agence immobilière premium à Tanger — Vente • Location • Gestion • Expatriés • VIP"
      />

      <section className="py-14 bg-[#fff3f8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div className="bg-white border rounded-2xl p-6 leading-relaxed text-gray-700">
            <p className="font-medium text-gray-900">
              Avec 13 ans d’expérience, Maxula House est l’agence immobilière de référence à Tanger.
            </p>
            <p className="mt-4">
              Vente, location, gestion locative, chasse immobilière, conciergerie & services VIP —
              avec un accompagnement premium adapté aux standards internationaux.
            </p>
          </div>

          <Box title="Pourquoi choisir Maxula House ?" icon={<FiShield />}>
            <ul className="space-y-2">
              {[
                "13 ans d’expertise & réseau solide",
                "Spécialistes des expatriés & investisseurs",
                "Biens sélectionnés et vérifiés",
                "Transparence, sécurité, professionnalisme",
                "Accompagnement de A à Z"
              ].map((x) => (
                <li key={x} className="flex items-start gap-2">
                  <FiCheckCircle className="text-[#e11d7b] mt-0.5" />
                  <span>{x}</span>
                </li>
              ))}
            </ul>
          </Box>

          <Box title="Nos services complets" icon={<FiHome />}>
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                "Vente (accompagnement jusqu’au notaire)",
                "Location (biens & profils sélectionnés)",
                "Gestion locative (loyers, entretien, rapports)",
                "Chasseur immobilier (nous trouvons le bien idéal)",
                "Conciergerie & VIP (chauffeur, installation, aide administrative)"
              ].map((x) => (
                <div key={x} className="flex items-start gap-2">
                  <FiCheckCircle className="text-[#e11d7b] mt-0.5" />
                  <span>{x}</span>
                </div>
              ))}
            </div>
          </Box>

          <Box title="Expatriés & investisseurs" icon={<FiUsers />}>
            <p>
              Nous accompagnons : Français, Suisses, Belges, Espagnols, Marocains du monde, retraités,
              entrepreneurs et investisseurs étrangers.
            </p>
            <p className="mt-3 text-sm text-gray-600">
              Tanger est une ville stratégique : CAN 2025 & Coupe du Monde 2030 → forte demande en achat, location et investissement.
            </p>
          </Box>

          <div className="flex justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-[#e11d7b] text-white font-semibold shadow hover:shadow-lg transition"
            >
              Contacter Maxula House
            </Link>
          </div>

          <div className="bg-white border rounded-2xl p-6 text-sm text-gray-700">
            <h3 className="font-bold mb-3">📞 Contact Maxula House</h3>
            <p className="flex items-center gap-2"><FiMapPin className="text-[#e11d7b]" /> Avenue Beethoven, Résidence Oumnia 1, Bureau 83, Tanger</p>
            <p className="mt-2 flex items-center gap-2"><FiPhone className="text-[#e11d7b]" /> Fixe : 0539 34 24 94</p>
            <p className="mt-2 flex items-center gap-2"><FiPhone className="text-[#e11d7b]" /> Yacine : +212 662 06 98 14 — Antoine : +212 661 59 28 57</p>
            <p className="mt-2 flex items-center gap-2"><FiMail className="text-[#e11d7b]" /> house@maxula.ma</p>
          </div>
        </div>
      </section>
    </div>
  );
}
